import { render, staticRenderFns } from "./ClaimsReports.vue?vue&type=template&id=ebc5d5fc&"
import script from "./ClaimsReports.vue?vue&type=script&lang=js&"
export * from "./ClaimsReports.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimsReports.vue"
export default component.exports